import {
  NOTIFY_ERROR,
  DISMISS_MESSAGE,
  NOTIFY_COMPLETE_CHECKOUT_ERROR
} from '../../GlobalStateContainer'

import {
  ERROR_USER_ALERT,
  UNKNOWN_USER_ALERT
} from '../../../SharedComponents/UserMessaging'


import {
  addToList,
  replaceInListById
} from '../../../util/listUtility'

const mapActionTypeToUserAlertType = (actionType) => {
  switch (actionType) {
    case NOTIFY_ERROR:
    case NOTIFY_COMPLETE_CHECKOUT_ERROR:
      return ERROR_USER_ALERT;
  }
  return UNKNOWN_USER_ALERT;
}

export function messages(state = [], action) {
  switch (action.type) {
    case NOTIFY_ERROR:
      return addToList(
        state,
        {
          type: mapActionTypeToUserAlertType(action.type),
          text: action.message,
          id: action.messageId
        });
    case NOTIFY_COMPLETE_CHECKOUT_ERROR:
      return addToList(
        state,
        {
          type: mapActionTypeToUserAlertType(action.type),
          text: "We're sorry, but are unable to complete submitting your quote. Please reload the page and try again, or contact customer service.",
          id: action.messageId
        });
    case DISMISS_MESSAGE:
      return replaceInListById(
        state,
        Object.assign({}, state.filter(m => m.Id === action.messageId)[0], { dismissed: true }))
  }
  return state;
}
